import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CustomCmsVideoComponent } from '../../../models/cms-links.model';

@Component({
    selector: 'app-homepage-paragraph-section4',
    templateUrl: './homepage-paragraph-section4.component.html',
    styleUrl: './homepage-paragraph-section4.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomepageParagraphSection4Component implements OnInit {

  public componentData: CustomCmsVideoComponent;

  constructor(public component: CmsComponentData<CustomCmsVideoComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
